import axios from 'axios';
import Cookies from 'js-cookie';

import { openModal } from '@help/modal.js';
import { validator400, validator400Plus } from '@utils/input_validator.js';
import { maskedTelInputs } from '@utils/masked_tel_inputs.js';
import { inputsCleanCrossHandler } from '@utils/inputs_with_clean_cross.js';


export function submitForm(appealForm) {
  const errorTexts = appealForm.querySelectorAll('.error-basic-text');
  const apiUrl = '/api/v1/appeal/create/';
  const inputs = appealForm.querySelectorAll('.form-input');
  const formData = {
    name: '',
    phone: '',
    email: '',
    text: ''
  };

  collectFormData();
  console.log(formData)

  const csrfToken = Cookies.get('csrftoken');
  axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
  return axios.post(apiUrl, formData)
    .then(response => {
      const text = 'Your message has been successfully sent.<br> We will contact you soon!';
      openModal(text);
      cleanFormInputs(appealForm);
    })
    .catch(error => {
      console.log('error', error)
      if (400 < error.response.status) {
        validator400Plus(inputs, errorTexts);
      } else {
        validator400(
          error.response.data.errors[0].state,
          inputs,
          errorTexts,
          false,
          true
        );
      };
    });

    function collectFormData() {
      inputs.forEach(input => {
        formData[input.name] = input.value;
      });
    };
  };

export async function appealFormHandler() {
  const appealForm = document.querySelector('.create-appeal-form');
  console.log('A', appealForm)
  if (appealForm) {
    const submitButton = appealForm.querySelector('.send-appeal-btn');

    maskedTelInputs();
    inputsCleanCrossHandler();

    appealForm.addEventListener('submit', function (e) {
      e.preventDefault();
    });

    submitButton.addEventListener('click', () => {
      submitButton.classList.add('disabled');

      submitForm(appealForm);

      window.setTimeout(() => {
        submitButton.classList.remove('disabled');
      }, 3000);
    })
  }

}

export function cleanFormInputs(appealForm) {
  const inputs = appealForm.querySelectorAll('.form-input');
  inputs.forEach(element => {
    element.value = '';
    element.nextElementSibling.classList.remove('has-content');
  });
}
